import React from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { Card } from "antd";

const currencyFormatter = (value) =>
  value?.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ background: "#fff", border: "1px solid #ccc", padding: 10 }}>
        <div><b>Competência:</b> {label}</div>
        <div style={{ color: "#1890ff" }}>Previsto: {currencyFormatter(payload[0]?.payload?.previsto)}</div>
        <div style={{ color: "#52c41a" }}>Recebido: {currencyFormatter(payload[0]?.payload?.recebido)}</div>
        <div style={{ color: "#faad14" }}>Em risco: {currencyFormatter(payload[0]?.payload?.em_risco)}</div>
      </div>
    );
  }
  return null;
};

const ForecastParcelasChartV2 = ({ data, loading }) => (
  <Card title="Evolução Receita Prevista x Recebida" loading={loading} style={{ marginTop: 16 }}>
    <ResponsiveContainer width="100%" height={320}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="competencia" />
        <YAxis tickFormatter={currencyFormatter} />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Line type="monotone" dataKey="previsto" name="Previsto" stroke="#1890ff" strokeWidth={2} dot={false} />
        <Line type="monotone" dataKey="recebido" name="Recebido" stroke="#52c41a" strokeWidth={2} dot={false} />
        <Line type="monotone" dataKey="em_risco" name="Em risco" stroke="#faad14" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  </Card>
);

export default ForecastParcelasChartV2;
